import React, { Fragment, useEffect, useState } from "react";
import { PiShoppingCartBold } from "react-icons/pi";
import { IoSearchOutline } from "react-icons/io5";
import { Menu, Transition } from "@headlessui/react";
import { TbCategory } from "react-icons/tb";
import DesktopMenu from "./DesktopMenu";
import { useSelector, useDispatch } from "react-redux";
import { categoryList } from "../redux/slices/categorySlice";
import { Link, useNavigate, useParams } from "react-router-dom";
import kabelmarketlogo from "../assets/kabelmarketlogo.png";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const Navbar = () => {
  const cart = useSelector((state) => state.cart.basket);
  const categories = useSelector((state) => state.category.data);
  const dispatch = useDispatch();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    dispatch(categoryList());
  }, [dispatch]);

  const toggleMobileMenu = () => {
    const mobileMenu = document.getElementById("mobile-menu");
    mobileMenu.classList.toggle("hidden");
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const { catname = "all", category = "all" } = useParams();

  const getFilterUrl = (filter) => {
    const filterCategory = filter.category || category;
    const filtercatName = filter.catname || catname;
    return `/search/category/${filterCategory}/name/${filtercatName}`;
  };

  const navigate = useNavigate();
  const [name, setName] = useState("");
  const submitHandler = (e) => {
    e.preventDefault();
    if (name === "") return;
    navigate(`/search/name/${name}`);
  };

  return (
    <>
      <nav className="bg-white sticky w-full top-0 z-[9999] shadow-sm border-b border-gray-100">
        <div className="mx-auto sm:max-w-[90vw] px-3 sm:px-6 lg:px-8 py-2">
          <div className="relative flex h-16 items-center justify-between">
            <div className="absolute inset-y-0 left-0 flex items-center sm:hidden">
              <button
                type="button"
                className="relative inline-flex items-center justify-center rounded-md p-2 bg-yellow-400 text-[#242424] hover:bg-yellow-500 transition-colors focus:outline-none focus:ring-2 focus:ring-inset focus:ring-yellow-300"
                aria-controls="mobile-menu"
                aria-expanded={mobileMenuOpen}
                onClick={toggleMobileMenu}
              >
                <span className="sr-only">Open main menu</span>
                {!mobileMenuOpen ? (
                  <svg
                    className="block h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
                    />
                  </svg>
                ) : (
                  <svg
                    className="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                )}
              </button>
            </div>

            <div className="flex flex-1 items-center justify-center sm:items-stretch sm:justify-start">
              <Link to="/" className="flex flex-shrink-0 items-center">
                <img
                  className="w-[130px] lg:w-[150px] h-auto max-h-[11vh]"
                  src={kabelmarketlogo}
                  alt="kabelmarket.az"
                />
              </Link>

              <div className="hidden sm:ml-6 sm:flex w-full items-center justify-center">
                {/* Improve the search form with better transitions */}
                <form
                  onSubmit={submitHandler}
                  className="w-full max-w-[700px] border border-gray-200 rounded-full hover:shadow-md focus-within:shadow-md focus-within:border-yellow-400 transition-all duration-300"
                >
                  <div className="relative h-full w-full flex items-center">
                    <div className="flex absolute inset-y-0 left-0 items-center pl-3 pointer-events-none">
                      <IoSearchOutline className="w-5 h-5 text-gray-500" />
                    </div>
                    <input
                      type="search"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      id="default-search"
                      className="block outline-none p-3.5 pl-10 w-full text-sm text-[#242424] bg-transparent border-none rounded-full"
                      placeholder="Məhsulu axtar..."
                    />
                    <button
                      type="submit"
                      className="absolute right-1.5 p-2 bg-yellow-400 hover:bg-yellow-500 text-[#242424] rounded-full transition-colors duration-300 focus:ring-2 focus:ring-yellow-300"
                      aria-label="Search"
                    >
                      <IoSearchOutline className="w-4 h-4" />
                    </button>
                  </div>
                </form>
              </div>
            </div>

            <div className="flex inset-y-0 right-0 items-center sm:static sm:inset-auto sm:ml-6 sm:pr-0">
              {/* Improve cart button with better hover effects */}
              <a
                href="/basket"
                className="relative inline-flex items-center justify-center py-2 px-4 font-medium text-[#242424] bg-gray-50 hover:bg-gray-100 rounded-lg transition-all duration-300 hover:shadow-sm"
              >
                <div className="relative">
                  <PiShoppingCartBold className="text-[26px] text-yellow-500" />
                  {cart.length > 0 && (
                    <span className="absolute -top-2 -right-2 bg-yellow-400 text-xs font-bold rounded-full h-5 w-5 flex items-center justify-center shadow-sm transition-transform duration-300 hover:scale-110">
                      {cart.length}
                    </span>
                  )}
                </div>
                <span className="ml-2 hidden sm:inline text-[16px]">Səbətim</span>
              </a>
            </div>
          </div>
        </div>

        {/* Mobile menu */}
        <div
          className={`sm:hidden overflow-hidden transition-all duration-300 ${mobileMenuOpen ? 'max-h-[80vh]' : 'max-h-0'}`}
          id="mobile-menu"
        >
          <div className={`px-4 pt-3 pb-5 ${mobileMenuOpen ? 'block' : 'hidden'}`}>
            {/* Improve mobile search form */}
            <form className="mb-5" onSubmit={submitHandler}>
              <div className="relative flex items-center">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <IoSearchOutline className="w-5 h-5 text-gray-500" />
                </div>
                <input
                  type="search"
                  id="mobile-search"
                  className="block w-full text-gray-900 bg-white rounded-lg border border-gray-200 shadow-sm outline-none p-3.5 pl-10 text-sm focus:border-yellow-400 focus:ring-2 focus:ring-yellow-400 transition-all duration-300"
                  placeholder="Məhsulu axtar..."
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
                <button
                  type="submit"
                  className="absolute right-2 p-1.5 bg-yellow-400 hover:bg-yellow-500 text-[#242424] rounded-lg transition-colors duration-300"
                >
                  <IoSearchOutline className="w-4 h-4" />
                </button>
              </div>
            </form>

            <div className="space-y-3">
              {/* Improve mobile menu buttons with better visual feedback */}
              <Menu
                as="div"
                className="relative w-full bg-yellow-400 hover:bg-yellow-500 transition-colors duration-300 rounded-lg shadow-sm"
              >
                <div>
                  <Menu.Button className="flex items-center w-full justify-between px-4 py-3 text-[16px] font-medium text-[#242424]">
                    Kateqoriyalar
                    <TbCategory className="ml-2 h-5 w-5 text-[#242424]" />
                  </Menu.Button>
                </div>

                <Transition
                  as={Fragment}
                  enter="transition ease-out duration-200"
                  enterFrom="transform opacity-0 scale-95"
                  enterTo="transform opacity-100 scale-100"
                  leave="transition ease-in duration-150"
                  leaveFrom="transform opacity-100 scale-100"
                  leaveTo="transform opacity-0 scale-95"
                >
                  <Menu.Items className="absolute left-0 z-10 mt-2 w-full origin-top-right rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                    <div className="py-1 max-h-[60vh] overflow-y-auto">
                      {categories?.map((category, index) => (
                        <Menu.Item key={index}>
                          {({ active }) => (
                            <Link
                              to={getFilterUrl({ category: category?.title })}
                              className={classNames(
                                active
                                  ? "bg-gray-100 text-gray-900"
                                  : "text-gray-700",
                                "block px-4 py-3 text-sm border-b border-gray-100 last:border-b-0"
                              )}
                            >
                              {category.title}{" "}
                              <span className="text-yellow-400 font-medium ml-1">
                                ({category?.productCount})
                              </span>
                            </Link>
                          )}
                        </Menu.Item>
                      ))}
                    </div>
                  </Menu.Items>
                </Transition>
              </Menu>

              <a
                href="/allproducts"
                className="flex items-center justify-between text-[#242424] w-full rounded-lg px-4 py-3.5 text-[16px] font-medium bg-gray-50 hover:bg-gray-100 transition-colors duration-300 shadow-sm hover:shadow"
              >
                Məhsullar
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-yellow-500" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
                </svg>
              </a>

              <a
                href="/#about"
                className="flex items-center justify-between text-[#242424] w-full rounded-lg px-4 py-3.5 text-[16px] font-medium bg-gray-50 hover:bg-gray-100 transition-colors duration-300 shadow-sm hover:shadow"
              >
                Haqqımızda
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-yellow-500" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </nav>
      <div className="hidden sm:block border-b border-gray-100">
        <DesktopMenu />
      </div>
    </>
  );
};

export default Navbar;
